// extracted by mini-css-extract-plugin
export var contentBody = "_e0-9";
export var headerImage = "_e0-2";
export var imageButton = "_e0-7";
export var imageButtonIcon = "_e0-8";
export var imageHeader = "_e0-4";
export var imageHeaderText = "_e0-5";
export var imageOverlay = "_e0-3";
export var imageTitle = "_e0-6";
export var imageWrapper = "_e0-1";
export var taskList = "_e0-a";
export var widget = "_e0-0";